import { useState } from 'react';
import { useBrokerDetailsStore } from '../../../../state/brokerDetailsStore';
import { useUploadCompanyLogoMutation } from '../../../../queries/brokerDetailsQueries';
import { handleAdminSuccess, handleAdminError } from '../../../../../../common/SharedFunctions';
import { useWaitOverlayStore } from '@apply/components';

export interface UseBrokerCompanyBrandingSubmitReturn {
    handleUploadCompanyLogo: () => Promise<void>;
    isSubmitting: boolean;
}

export const useBrokerCompanyBrandingSubmit = (validate: () => { isValid: boolean }): UseBrokerCompanyBrandingSubmitReturn => {
    const uploadCompanyLogoMutation = useUploadCompanyLogoMutation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleUploadCompanyLogo = async () => {
        if (!validate().isValid) return;
        const { setWaiting } = useWaitOverlayStore.getState();
        try {
            setIsSubmitting(true);
            setWaiting(true, 'Saving Company Logo...');
            const fileToUpload = useBrokerDetailsStore.getState().companyLogoFile;
            if (!fileToUpload) {
                //Catch all - validation should prevent this anyway...
                handleAdminError(new Error('No file selected.'));
                return;
            } else {
                await uploadCompanyLogoMutation.mutateAsync({
                    brokerId: useBrokerDetailsStore.getState().brokerId,
                    file: fileToUpload,
                });
                handleAdminSuccess('Company logo saved!');
            }
        } catch (ex) {
            handleAdminError(
                ex instanceof Error ? ex : new Error(String(ex)),
                'An unexpected error has occurred. Please try again.'
            );
        } finally {
            setIsSubmitting(false);
            setWaiting(false);
        }
    };

    return {
        handleUploadCompanyLogo,
        isSubmitting,
    };
};
